<template>
  <div>
    <div class="tw-bg-white tw-shadow tw-border-t tw-border-gray-200">
      <base-content class="tw-pb-0">
        <div class="tw-flex tw-items-center">
          <h1 class="tw-text-xl sm:tw-text-2xl tw-leading-tight tw-text-gray-900 tw-mb-0 tw-font-thin">Plans and Products</h1>
        </div>
        <base-tabs class="tw-mt-2 tw-pb-4 md:tw-pb-0 tw-mb-0" no-border @click="tabClick($event)">
          <div v-for="tab in tabs" :key="tab.route">
            <base-tab :selected="$route.meta.component === tab.component" :title="tab.label" />
          </div>
        </base-tabs>
      </base-content>
    </div>
    <base-content>
      <component :is="currentComponent" :businessId="businessId" />
    </base-content>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "BusinessOfferingsView",
  components: {
    Avatar: () => import("@/components/Avatar.vue"),
    BusinessPlans: () => import("@/views/business/business-plans/BusinessPlans.vue"),
    BusinessItemCategories: () => import("@/views/business/business-item-categories/BusinessItemCategories.vue"),
    BusinessPrograms: () => import("@/views/business/business-programs/BusinessPrograms.vue"),
    BusinessMedications: () => import("@/views/business/business-medications/BusinessMedications.vue"),
  },
  props: {
    businessId: String,
  },
  computed: {
    ...mapGetters("organization", ["organization"]),
    currentComponent: function() {
      return this.$route.meta.component;
    },
    tabs() {
      let tabList = [];

      tabList.push(
        {
          label: "Offered Plans",
          component: "BusinessPlans",
          route: "plans",
        },
        {
          label: "Products",
          component: "BusinessItemCategories",
          route: "products",
        },
      );

      if (this.organization.usePrescriptionProgramSetting) {
        tabList.push({
          label: "Rx Programs",
          component: "BusinessPrograms",
          route: "programs",
        });
        tabList.push({
          label: "Medications",
          component: "BusinessMedications",
          route: "medications",
        });
      }

      return tabList;
    },
  },
  methods: {
    tabClick(tabTitle) {
      const tab = this.tabs.find((t) => t.label === tabTitle);

      if (this.$route.path !== "/businesses/" + this.businessId + "/offerings/" + tab.route)
        this.$router.push({
          path: "/businesses/" + this.businessId + "/offerings/" + tab.route,
        });
    },
  },
};
</script>
